import React, { useEffect } from 'react'
import { useRoutes } from 'react-router-dom'
import PublicIp from 'public-ip'
import { ThemeProvider } from '@material-ui/core'
import GlobalStyles from './components/GlobalStyles'
import { toast } from 'react-toastify'

// components
import theme from './theme'
import routes from './routes'

import './assets/styles/header.css'
import './assets/styles/product.css'
import './assets/styles/cart.css'
import './assets/styles/order.css'

import 'react-toastify/dist/ReactToastify.css'
import 'react-perfect-scrollbar/dist/css/styles.css'
import './mixins/chartjs'

// contexts
import { ShoppingCartProvider } from './contexts/ShoppingCart'
import { ToastProvider } from './contexts/Toast'

const App = () => {
   const routing = useRoutes(routes)

   useEffect(() => {
      const prepareApplication = async () => {
         localStorage.setItem(
            'ip_address',
            await PublicIp.v4({
               fallbackUrls: ['https://ipconfig.co/ip']
            })
         )

         toast.configure()
      }

      prepareApplication()
   }, [])

   return (
      <ThemeProvider theme={theme}>
         <ToastProvider>
            <ShoppingCartProvider>
               <GlobalStyles />
               {routing}
            </ShoppingCartProvider>
         </ToastProvider>
      </ThemeProvider>
   )
}

export default App
